import { ChartSkeleton } from "@repo/ui/Skeletons/skeletons";
import type { FC } from "react";

export const ReportLayoutSkeleton: FC = () => (
  <div className="flex items-center justify-center p-10">
    <div className="h-64 w-full max-w-96">
      <ChartSkeleton />
    </div>
  </div>
);
